import Custombutton from "../../../utils/Custombutton";
import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header/Header";
import Footer from "../../layouts/Footer";

const OurTeam = () => {
  return (
    <div
    className="hero heros ourteam"
    style={{
      height: "100% !important ",
      background: " linear-gradient(61deg, #070707 50.84%, #222 96.86%)",
    }}
  > <br />
      <Header />
      <div id="ourteam" className="position-relative">
        <div className=" ourteam " style={{ background: "none" }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12 blogs">
                  <h1 className="text-center gradient-text  mt-5 mb- 5">Our Team</h1>
              </div>
              <div className="row equal-height ms-0">
                <div className="col-xl-4  d-flex flex-column mb-4">
                  <div className="teams-card second d-flex flex-column justify-content-center">
                    <h4>Mahad</h4>
                    <span>CTO</span>
                    <br />
                    <h6>
                    Mahad's five-year tenure in the cryptocurrency sector, working on diverse projects, positions him as a key figure in overseeing Cosmic Network's technological direction, ensuring that the company remains at the forefront of blockchain innovation.                    </h6>
                  </div>
                </div>

                <div className="col-xl-4  d-flex flex-column mb-4">
                  <div className="teams-card second d-flex flex-column justify-content-center">
                    <h4>xA</h4>
                    <span>Lead Blockchain Developer</span>
                    <br />
                    <h6>
                      xA, Cosmic Network's Lead Blockchain Developer, uniquely combines expertise in blockchain, web development, and artificial intelligence, underscored by a dedication to AI ethics.
                    </h6>
                  </div>
                </div>

                <div className="col-xl-4  d-flex flex-column mb-4">
                  <div className="teams-card second d-flex flex-column justify-content-center">
                    <h4>Q</h4>
                    <span>Project Manager</span>
                    <br />
                    <h6>
                    With 17 years of experience in tech and real-time products, Q has led multidisciplinary teams on projects for high-profile clients like Toyota and Samsung. His extensive experience ensures the seamless integration and execution of Cosmic Network's projects.                    </h6>
                  </div>
                </div>

                <div className="col-xl-4  d-flex flex-column mb-4">
                  <div className="teams-card second d-flex flex-column justify-content-center">
                    <h4>Jay</h4>
                    <span>Senior Network Developer</span>
                    <br />
                    <h6>
                    Specializing in blockchain innovation, Jay's extensive experience encompass working on blockchain forks, decentralized exchanges, tokenization, and NFT marketplaces. His deep expertise in blockchain technology is instrumental in propelling Cosmic Network's projects forward.                    </h6>
                  </div>
                </div>

                <div className="col-xl-4  d-flex flex-column mb-4">
                  <div className="teams-card second d-flex flex-column justify-content-center">
                    <h4>Zain</h4>
                    <span>Network Engineer</span>
                    <br />
                    <h6>
                    With years of experience as a Network Engineer, Zain brings a comprehensive skill set that includes the MERN stack, AWS, SQL/NoSQL databases, CI/CD, Blockchain, and Web3 technologies. His dedication to delivering high-quality, secure software solutions marks him as an asset to the development team.                    </h6>
                  </div>
                </div>

                <div className="col-xl-4  d-flex flex-column mb-4">
                  <div className="teams-card second d-flex flex-column justify-content-center">
                    <h4>Alex</h4>
                    <span>Full Stack Developer</span>
                    <br />
                    <h6>
                    Specializing in web application development, Alex’s expertise spans over five years, with a focus on creating scalable, high-performance applications. His proficiency in a wide range of technologies, from React to NodeJs and MongoDB, alongside his experience with agile methodologies, makes him a key player in the development team.                    </h6>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      </div>
  );
};

export default OurTeam;
